import { makeStyles } from "@material-ui/core/styles";
import React from "react";

const useStyles = makeStyles({
  container: {
    position: "absolute", // be the size of its content
    "@media print": {
      visibility: "hidden",
      display: "none",
    },
  },
});

interface Props {
  children: React.ReactNode;
}

const NoPrint: FC<Props> = ({ children }) => {
  const classes = useStyles();

  return <div className={classes.container}>{children}</div>;
};

export default NoPrint;
